module.exports = __webpack_public_path__ + "static/turtle-creek-house19-cc8d37b6f0145a8b3bb71bf8a9f5ab72.jpg";